export default {
  type: 'Type',
  all: 'All',
  analysis: 'Material analysis',
  specification: 'Material specification',
  analysisList: 'Material analyses',
};
